import { Toaster } from 'sonner';

export function AppToaster() {
  return (
    // react-aria "top layer": clicks on a toast must not be swallowed or
    // treated as an outside-interaction while a modal overlay is open
    // (react-aria checks [data-react-aria-top-layer] in useInteractOutside +
    // ariaHideOutside). Value must be the string "true" — ariaHideOutside's
    // observer path checks dataset.reactAriaTopLayer === 'true'.
    <div data-react-aria-top-layer='true'>
      <Toaster
        position='bottom-right'
        toastOptions={{
          style: {
            background: 'var(--color-bg-primary)',
            border: '1px solid var(--color-border-secondary)',
            color: 'var(--color-fg-primary)',
            // Elevation + radius from the theme.css ladder (VISUAL_STYLE_GUIDE.md:
            // toast = transient overlay → shadow-lg; large in-flow container →
            // rounded-xl). Inline (not classNames) so sonner's own stylesheet
            // can't out-specificity the token values.
            boxShadow: 'var(--shadow-lg)',
            borderRadius: 'var(--radius-xl)',
            fontSize: '14px',
            padding: '12px 16px',
          },
          classNames: {
            success:
              '[&_[data-icon]]:text-utility-success-500 [&_[data-icon]]:bg-utility-success-50 [&_[data-icon]]:rounded-full [&_[data-icon]]:p-1',
            error:
              '[&_[data-icon]]:text-utility-error-500 [&_[data-icon]]:bg-utility-error-50 [&_[data-icon]]:rounded-full [&_[data-icon]]:p-1',
            warning:
              '[&_[data-icon]]:text-utility-warning-500 [&_[data-icon]]:bg-utility-warning-50 [&_[data-icon]]:rounded-full [&_[data-icon]]:p-1',
            description: 'text-fg-tertiary text-xs mt-1',
          },
        }}
        gap={16}
        offset={16}
      />
    </div>
  );
}
